"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.summerPeakSeasonality = exports.gradualSeasonality = exports.quarterlySeasonality = exports.flatSeasonality = exports.pricingTemplateData = exports.SeasonalityTemplate = void 0;
const UnsupportedValueError_1 = __importDefault(require("../../util/UnsupportedValueError"));
var SeasonalityTemplate;
(function (SeasonalityTemplate) {
    SeasonalityTemplate["Gradual"] = "Gradual Seasonality";
    SeasonalityTemplate["FlatRate"] = "Flat Rate Seasonality";
    SeasonalityTemplate["Quarterly"] = "Quarterly Seasonality";
    SeasonalityTemplate["SummerPeak"] = "Summer Peak Seasonality";
})(SeasonalityTemplate = exports.SeasonalityTemplate || (exports.SeasonalityTemplate = {}));
const pricingTemplateData = (t) => {
    switch (t) {
        case SeasonalityTemplate.Gradual: return exports.gradualSeasonality;
        case SeasonalityTemplate.FlatRate: return exports.flatSeasonality;
        case SeasonalityTemplate.Quarterly: return exports.quarterlySeasonality;
        case SeasonalityTemplate.SummerPeak: return exports.summerPeakSeasonality;
        default: throw new UnsupportedValueError_1.default(t);
    }
};
exports.pricingTemplateData = pricingTemplateData;
exports.flatSeasonality = {
    january: 50,
    february: 50,
    march: 50,
    april: 50,
    may: 50,
    june: 50,
    july: 50,
    august: 50,
    september: 50,
    october: 50,
    november: 50,
    december: 50
};
exports.quarterlySeasonality = {
    // min price winter, std price spring, max price summer,
    // min autumn
    january: 0,
    february: 0,
    march: 50,
    april: 50,
    may: 50,
    june: 100,
    july: 100,
    august: 100,
    september: 0,
    october: 0,
    november: 0,
    december: 0
};
exports.gradualSeasonality = {
    // Gradual jumps from Min January > Max August, then steep
    // fall off until December
    january: 10,
    february: 20,
    march: 40,
    april: 55,
    may: 70,
    june: 85,
    july: 95,
    august: 100,
    september: 60,
    october: 40,
    november: 20,
    december: 10
};
exports.summerPeakSeasonality = {
    // Max price in summer, standard the rest
    january: 50,
    february: 50,
    march: 50,
    april: 50,
    may: 50,
    june: 100,
    july: 100,
    august: 100,
    september: 50,
    october: 50,
    november: 50,
    december: 50
};
//# sourceMappingURL=seasonality.js.map